"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarContentItem = void 0;
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const SideBarOpenStateStore_1 = __importDefault(require("../utils/zustand-stores/SideBarOpenStateStore"));
function SideBarContentItem({ onClick, sx, children, ...rest }) {
    const { setOpen } = (0, SideBarOpenStateStore_1.default)();
    const theme = (0, material_1.useTheme)();
    const defaultSX = {
        fontFamily: 'Effra',
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '1.5rem',
        letterSpacing: '0.025rem',
        color: theme.palette.primary.contrastText,
        justifyContent: 'start',
        paddingX: '0px',
        textTransform: 'none',
    };
    const mergedSX = { ...defaultSX, ...sx };
    return (react_1.default.createElement(material_1.Button, { onClick: e => {
            setOpen(false);
            if (onClick) {
                onClick(e);
            }
        }, sx: mergedSX, ...rest },
        react_1.default.createElement("div", { className: "flex flex-row gap-[0.5rem]" }, children)));
}
exports.SideBarContentItem = SideBarContentItem;
